import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

interface TeamMember {
  name: string;
  title: string;
  image: string;
}

interface Card {
  title: string;
  description: string;
  icon: string; // Bootstrap icon class
}

@Component({
  selector: 'app-about',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  encapsulation: ViewEncapsulation.None, // ✅ Make sure this line is here
})
export class AboutComponent implements OnInit {
  constructor(
    private title: Title,
    private meta: Meta,
    private canonicalService: CanonicalService
  ) {}

  ngOnInit(): void {
    // Set page title
    this.title.setTitle('About MALtech | Leading IT & Tech Innovators');

    // Set meta description
    this.meta.updateTag({
      name: 'description',
      content:
        'MALtech delivers top-tier IT services tailored by specialized skills. We provide optimal solutions to meet your business technology needs.',
    });

    // Set meta keywords
    this.meta.updateTag({
      name: 'keywords',
      content: 'about, information, it services',
    });

    this.canonicalService.setCanonicalURL('about/');
  }
  scrollToPlans() {
    const plansSection = document.getElementById('email-plans');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  cards: Card[] = [
    {
      title: 'Mission',
      description:
        'Deliver services that define excellence. Build finest products, inspire processes, and implement the right solution.',
      icon: 'bi-bullseye',
    },
    {
      title: 'Vision',
      description:
        'Be the most preferred technology partner. Drive universal access to innovation and productivity.',
      icon: 'bi-trophy',
    },
    {
      title: 'Belief',
      description:
        'Challenges are opportunities in disguise. We excel in delivering optimal solutions.',
      icon: 'bi-heart',
    },
  ];

  timeline = [
    {
      year: '2019',
      title: 'Founded MALtech',
      desc: 'MALtech was established with a vision to revolutionize the tech landscape, focusing on custom software development and innovative solutions.',
      icon: 'bi-rocket-fill',
    },
    {
      year: '2019',
      title: 'Launched First Product',
      desc: 'MALtech successfully launched its first product, a groundbreaking application that set new standards in user experience and functionality.',
      icon: 'bi-box-seam',
    },
    {
      year: '2020',
      title: 'Expanded Team',
      desc: 'The team at MALtech expanded significantly, bringing in top talent to enhance capabilities and drive further innovation.',
      icon: 'bi-people-fill',
    },
    {
      year: '2021',
      title: 'Cloud & DevOps Services',
      desc: 'MALtech integrated Cloud and DevOps services, enabling clients to optimize operations, enhance scalability, and achieve greater efficiency.',
      icon: 'bi-cloud',
    },
    {
      year: '2022',
      title: 'AI & ML Capabilities',
      desc: 'MALtech ventured into AI & ML, developing solutions with advanced analytical and predictive capabilities.',
      icon: 'bi-cpu',
    },
    {
      year: '2023',
      title: 'Global Expansion',
      desc: 'MALtech expanded globally, establishing presence in key markets to serve a broader client base.',
      icon: 'bi-globe2',
    },
    {
      year: '2024',
      title: 'Strategic Partnerships',
      desc: 'MALtech formed strategic partnerships with industry leaders to deliver integrated solutions.',
      icon: 'bi-person-check',
    },
    {
      year: '2025',
      title: 'Future Vision',
      desc: 'Looking ahead, MALtech envisions growth and innovation, leading in emerging technologies.',
      icon: 'bi-eye',
    },
  ];

  teamMembers: TeamMember[] = [
    { name: 'Madhu Kiran', title: 'CEO', image: 'assets/team/Madhu-sir.webp' },
    {
      name: 'Ratnakara Babu',
      title: 'CAO',
      image: 'assets/team/Ratnakar.webp',
    },
    {
      name: 'Ramya',
      title: 'Sr.Business Analyst',
      image: 'assets/team/Ramya.webp',
    },
    {
      name: 'Guru Brahmam',
      title: 'Sr.Associate Software Engineer',
      image: 'assets/team/guru.webp',
    },
    {
      name: 'Jaya Lakshmi',
      title: 'Sr.Associate Software Engineer',
      image: 'assets/team/jayalakshmi.webp',
    },
    {
      name: 'Nagaraju',
      title: 'Jr.Associate Software Engineer',
      image: 'assets/team/nagaraju.webp',
    },
    {
      name: 'Indrani',
      title: 'Jr.Associate Software Engineer',
      image: 'assets/team/indrani.webp',
    },
    {
      name: 'Jashuva',
      title: 'Jr.Associate Software Engineer',
      image: 'assets/team/jashuva.webp',
    },
    {
      name: 'Anand Kumar',
      title: 'Jr.Associate Software Engineer',
      image: 'assets/team/anand.webp',
    },
    {
      name: 'Sai Sujith',
      title: 'Jr.Associate Software Engineer',
      image: 'assets/team/sujith.webp',
    },
  ];
}
